import axiosClient from "api/axiosClient";
import endpoints from "api/endpoints";

const publicOrderConfig = (accessToken) => ({
  skipAdminAuth: true,
  skipCustomHeader: true,
  timeout: 60000,
  ...(accessToken
    ? { headers: { Authorization: `Bearer ${accessToken}` } }
    : {}),
});

export const requestOrderCreateToken = () =>
  axiosClient.post(
    endpoints.PUBLIC_ORDER_TOKEN,
    undefined,
    publicOrderConfig()
  );

export const createPublicOrder = (payload, accessToken) =>
  axiosClient.post(
    endpoints.PUBLIC_ORDERS,
    payload,
    publicOrderConfig(accessToken)
  );

export const getPublicOrder = (orderId, trackingToken) =>
  axiosClient.get(
    endpoints.PUBLIC_ORDER_BY_ID(orderId),
    publicOrderConfig(trackingToken)
  );
